import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Stylesheets/Monthtimeline.css";

import AOS from "aos";

const timelineData = [
  {
    time: "Project Completion",
    icon: "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img73868_IMG.png",
    title: "Project Continuation and Completion",
    description: [
      "Final phase of project development.",
      "Includes testing, debugging, and optimization.",
    ],
    thumbs: [],
    badges: [{ text: "Final Project", color: "primary" }],
  },
  {
    time: "Mock Interviews",
    icon: "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img67801_IMG.png",
    title: "Mock Interviews",
    description: [
      "Simulation of real technical interviews.",
      "Covers coding, problem-solving, logical reasoning, and HR-style questions.",
      "Helps trainees prepare for Phase 2 employment evaluation.",
    ],
    thumbs: [],
    badges: [{ text: "Interview Prep", color: "success" }],
  },
];

const Month5 = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
    window.scrollTo({ behavior: "smooth", top: 0 });
  }, []);

  return (
    <section
      id="monthtimeline"
      className="min-vh-100 position-relative overflow-hidden"
    >
      {/* Background Video */}
      {/* <div className="home-bg">
        <video loop autoPlay muted playsInline>
          <source src={bg_video} />
        </video>
        <div className="video-overlay"></div>
      </div> */}

      <div className="container text-light position-relative">
        <h1 className="text-center gradient-text mt-5 py-3 fw-bold monthtimeline" style={{fontFamily:"'Merriweather', serif"}}>
          Mini Project (Part 2) + Mock Interview
        </h1>
        <div className="timeline">
          {timelineData.map((item, index) => (
            <div className="timeline-row" data-aos="fade-up" key={index}>
              <div
                className="timeline-time text-light fw-bold"
                data-aos="zoom-in-up"
              >
                {item.time}
              </div>
              <div className="timeline-content">
                <img
                  src={item.icon}
                  alt={item.title}
                  className="timeline-icon"
                />
                <h4 style={{color:" rgb(7, 223, 252)"}}>{item.title}</h4>

                {/* Description as <ul> */}
                <ul>
                  {item.description.map((point, i) => (
                    <li key={i}>{point}</li>
                  ))}
                </ul>

                <div>
                  {item.badges.map((badge, i) => (
                    <span
                      key={i}
                      className={`badge rounded-pill bg-${badge.color} ${
                        i > 0 ? "ms-1" : ""
                      }`}
                    >
                      {badge.text}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Month5;
